import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/Icons/search.svg";
import { ReactComponent as NewBlockSearchIcon } from "../../assets/Icons/newblocksearch.svg";
import { ReactComponent as CloseIcon } from "../../assets/Icons/closeFilled.svg";
import { ReactComponent as MenuIcon } from "../../assets/Icons/MenuIcon.svg";
import { ReactComponent as CircleArrow } from "../../assets/Icons/filledCircleArrow.svg";
import { ReactComponent as SignOutIcon } from "../../assets/Icons/signOut.svg";
import { ReactComponent as FilterIcon } from "../../assets/Icons/filter.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getUserDetails } from "../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import { setRTL } from "../../Redux/RTL/RTLSlice";
import {
  appInfo,
  authenticate2,
  getUserSubscription,
  getLanguageList,
  updateUserLanguage,
  authenticate,
} from "../../network/service";
import * as service from "./service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { getLanguageModal } from "../../Redux/LanguageModal/languageModalSlice";
import Translate from "../Multilanguage/Translate";
import { useTranslation } from "react-i18next";
import Util from "./util";
import { useTranslateText } from "../Multilanguage/Translate";
const Header = (props) => {
  const { isCheckoutPath } = props;
  const { fetchMenuItems,
    fetchUserSubscriptionDetails,
    searchSubmit,
    searchSubmitBrowseMore,
    logoutHandler,
    tokenAuthenticate,
    languageHandler,
    menuNavigateHandler,
    hexToRgb,
    handleLanguageClick,
    fetchLanguageOptions,
    handleLanguageChange,
    renderMenuItems } = Util();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  // const selectedLanguage = useSelector((state) => state?.languageModal?.value?.selectedLanguage);
  const selectedLanguageCode = useSelector((state) => state?.languageModal?.value?.selectedLanguageCode);
  const { i18n } = useTranslation();

  const [inputValue, setInputValue] = useState("");
  const [searchResults, setSearchResults] = useState("");
  const [searchActive, setSearchActive] = useState(false);
  const [menuItems, setMenuItems] = useState();
  const [mainMenuItems, setMainMenuItems] = useState([]);
  const [browseHover, setBrowseHover] = useState("");
  const [browseMoreMediumDevice, setBrowseMoreMediumDevice] = useState(false);
  const [position, setPosition] = useState(window.pageYOffset);
  const [headerVisible, setHeaderVisible] = useState(true);
  const [userInfo, setUserInfo] = useState(false);
  const [previousLocation, setPreviousLocation] = useState("");
  const [isSubscribedUser, setIsSubscribedUser] = useState(false)
  const [languageOptions, setLanguageOptions] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({ short_code: 'en' });
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [isRTL, setIsRTL] = useState(useSelector((state) => state?.rtl?.isRTL));
  const [showVideoQualityDropdown, setShowVideoQualityDropdown] = useState(false);
  const [activeMenuTracker, setActiveMenuTrackerState] = useState(() => {
    const saved = localStorage.getItem("activeMenuTracker");
    return saved ? JSON.parse(saved) : null;
  });

  const setActiveMenuTracker = (tracker) => {
    setActiveMenuTrackerState(tracker);
    if (tracker) {
      localStorage.setItem("activeMenuTracker", JSON.stringify(tracker));
    } else {
      localStorage.removeItem("activeMenuTracker");
    }
  };
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const searchRefContainer = useRef(null);
  const searchRefSmall = useRef(null);
  const searchRefSmallContainer = useRef(null);
  const lastInputWasKeyboard = useRef(false);
  const userInfoContainerRef = useRef(null);
  const browseMoreContainerRef = useRef(null);
  const justClosedUserInfo = useRef(false);
  const translateText = useTranslateText();
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  const eventId = location?.state?.eventId || localStorage.getItem("eventId")
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const buttonColor = projectInfo?.projectConfig?.config?.BUTTON_COLOR;
  const buttonSeclectionColor = projectInfo?.projectConfig?.config?.BUTTON_SELECTION_COLOR;
  const theme = projectInfo?.projectConfig?.config?.THEME;
  const filterRequired = projectInfo?.projectConfig?.config?.CUSTOM_FILTERS_REQUIRED;
  const pubid = projectInfo?.projectConfig?.pubid;

  // useEffect(() => {
  //   fetchLanguageOptions(appInfo, setLanguageOptions, setSelectedLanguage, projectInfo, userDetails, user);
  // }, [userDetails, user]);

  useEffect(() => {
    const pathSegments = window.location.pathname.split('/');
    setShowVideoQualityDropdown(pathSegments[pathSegments.length - 2] !== 'videos');
  }, [window.location.pathname]);

  useEffect(() => {
    dispatch(setRTL(selectedLanguage));
  }, [selectedLanguage, dispatch]);

  useEffect(() => {
    const handleScroll = () => {
      let moving = window.pageYOffset;
      // setHeaderVisible(position > moving);
      setPosition(moving);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });
  useEffect(() => {
    if (searchActive) {
      // searchRef?.current.focus();
      searchRefSmall?.current?.focus();
      searchRefSmallContainer?.current?.focus();
      setPreviousLocation(location);
    }
  }, [searchActive]);

  useEffect(() => {
    if (accessToken) {
      fetchUserSubscriptionDetails(appInfo, setIsSubscribedUser);
    }
  }, [user, accessToken]);

  useEffect(() => {
    fetchMenuItems(appInfo, setMenuItems, setMainMenuItems);
  }, [user]);

  useEffect(() => {
    if (activeMenuTracker && decodeURIComponent(activeMenuTracker.path) !== decodeURIComponent(location.pathname)) {
      setActiveMenuTracker(null);
    }
  }, [location.pathname, activeMenuTracker]);

  useEffect(() => {
    let handleOutClick = (e) => {
      if (
        !searchRefContainer?.current?.contains(e.target) &&
        !searchRefSmallContainer?.current?.contains(e.target)
      ) {
        setInputValue("");
        setSearchActive(false); //outside click
      }
    };

    window.addEventListener("click", handleOutClick);
    return () => {
      window.addEventListener("click", handleOutClick);
    };
  }, [searchRefContainer, searchRefSmallContainer]);

  useEffect(() => {
    if (browseHover === "show" && browseMoreContainerRef.current) {
      const first = browseMoreContainerRef.current.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
      if (first) first.focus();
    }
  }, [browseHover]);

  useEffect(() => {
    if (browseHover !== "show" || !browseMoreContainerRef.current) return;
    const node = browseMoreContainerRef.current;
    function handleFocusOut(e) {
      if (!node.contains(e.relatedTarget)) {
        setBrowseHover(null);
        setBrowseMoreMediumDevice(false);
      }
    }
    node.addEventListener("focusout", handleFocusOut);
    return () => node.removeEventListener("focusout", handleFocusOut);
  }, [browseHover, browseMoreContainerRef]);

  useEffect(() => {
    if (browseHover !== "show") return;
    const handleClickOrFocus = (e) => {
      if (browseMoreContainerRef.current && !browseMoreContainerRef.current.contains(e.target)) {
        setBrowseHover(null);
        setBrowseMoreMediumDevice(false);
      }
    };
    document.addEventListener('mousedown', handleClickOrFocus);
    document.addEventListener('focusin', handleClickOrFocus);
    return () => {
      document.removeEventListener('mousedown', handleClickOrFocus);
      document.removeEventListener('focusin', handleClickOrFocus);
    };
  }, [browseHover]);
  useEffect(() => {
    if (browseHover !== "show") return;
    function handleEvent(e) {
      if (
        browseMoreContainerRef.current &&
        !browseMoreContainerRef.current.contains(e.target)
      ) {
        setBrowseHover(null);
        setBrowseMoreMediumDevice(false);
      }
    }
    document.addEventListener("mousedown", handleEvent);
    document.addEventListener("focusin", handleEvent);
    return () => {
      document.removeEventListener("mousedown", handleEvent);
      document.removeEventListener("focusin", handleEvent);
    };
  }, [browseHover]);
  useEffect(() => {
    if (browseHover !== "show" || !browseMoreContainerRef.current) return;
    const node = browseMoreContainerRef.current;
    function handleFocusOut(e) {
      // If focus moves outside the container
      if (!node.contains(e.relatedTarget)) {
        setBrowseHover(null);
        setBrowseMoreMediumDevice(false);
      }
    }
    node.addEventListener("focusout", handleFocusOut);
    return () => node.removeEventListener("focusout", handleFocusOut);
  }, [browseHover]);

  useEffect(() => {
    const node = browseMoreContainerRef.current;
    if (!node) return;

    const handleFocusOut = (e) => {
      if (!node.contains(e.relatedTarget)) {
        setBrowseHover(null);
        setBrowseMoreMediumDevice(false);
      }
    };

    node.addEventListener("focusout", handleFocusOut);
    return () => node.removeEventListener("focusout", handleFocusOut);
  }, []);

  function handleUserInfoMenuKeyDown(e) {

    const focusable = Array.from(e.currentTarget.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (focusable.length === 0) return;
      if (!e.shiftKey && document.activeElement === last) {
        setUserInfo(false);
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        setUserInfo(false);
        justClosedUserInfo.current = true;
        const trigger = document.querySelector('.userInfo');
        if (trigger) trigger.focus();
      }
    }
    else if (e.key === 'Escape') {
      setUserInfo(false);
      const trigger = document.querySelector('.userInfo');
      if (trigger) trigger.focus();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const idx = focusable.indexOf(document.activeElement);
      if (idx > -1 && idx < focusable.length - 1) {
        focusable[idx + 1].focus();
      } else {
        first.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const idx = focusable.indexOf(document.activeElement);
      if (idx > 0) {
        focusable[idx - 1].focus();
      } else {
        last.focus();
      }
    }
  }

  function handleBrowseMoreKeyDown(e) {
    const focusable = Array.from(e.currentTarget.querySelectorAll('a,button,[tabindex]:not([tabindex="-1"])'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.key === 'Tab') {
      if (focusable.length === 0) return;
      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        setBrowseHover(null);
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        setBrowseHover(null);
      }
    } else if (e.key === 'Escape') {
      setBrowseHover(null);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      const idx = focusable.indexOf(document.activeElement);
      if (idx > -1 && idx < focusable.length - 1) {
        focusable[idx + 1].focus();
      } else {
        first.focus();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      const idx = focusable.indexOf(document.activeElement);
      if (idx > 0) {
        focusable[idx - 1].focus();
      } else {
        last.focus();
      }
    }
  }



  const buttonColorRgb = buttonColor ? hexToRgb(buttonColor) : '';
  const buttonSelection = buttonSeclectionColor ? hexToRgb(buttonSeclectionColor) : '';

  return (
    <>
      <ToastContainer />
      <div
        className={browseMoreMediumDevice ? "active overlayOne" : "overlayOne"}
      ></div>
      <div
        className={
          `${(position === 0 && (theme !== "LIGHT" && template !== "TEMPLATE_9")) ? "header-container" : "header-container background"} ${pubid === 50158 ? "header-white" : pubid === 50134 ? "header-black" : ""}`
        }
        aria-label="Site header"
      >
        <div className="wrapper">
          <div className="leftContainer" aria-label="Main navigation">
            <div className="menuIconContainer"
              aria-label="Open menu"
              role="button"
              tabIndex={0}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setBrowseMoreMediumDevice(true)}
            >
              <MenuIcon onClick={() => setBrowseMoreMediumDevice(true)}
                style={theme === "LIGHT" ? { color: "black" } : {}}
                aria-hidden="true"
              />
            </div>
            <div className="logoContainer">
              <Link to="/home" aria-label="Go to home page">
                <h1 className={`${projectInfo?.projectConfig?.pubid === 50147 ? 'template-11-logo' : ''}`}>
                  <img
                    src={projectInfo?.projectConfig?.config?.LOGO}
                    alt="Site logo"
                  />
                </h1>
              </Link>
            </div>
            <ul className={`${searchActive ? "hide browse" : "browse"} ${theme === "LIGHT" ? "white-bg" : ""}`} role="menubar" aria-label="Main menu" >
              {mainMenuItems?.length !== 0 ? (
                <>
                  {renderMenuItems(mainMenuItems, location.pathname, activeMenuTracker, setActiveMenuTracker, undefined, setBrowseHover, setBrowseMoreMediumDevice)}
                </>
              ) :
                (
                  <>
                    <li
                      className={browseHover === "show" ? "active" : "no-active"}
                      role="menuitem"
                      tabIndex={0}
                      aria-label="Browse more"
                      onClick={() => {
                        setBrowseMoreMediumDevice(true)
                      }}
                      onMouseOver={() => setBrowseHover("show")}
                      onMouseLeave={() => setBrowseHover(null)}
                      onFocus={e => {
                        setBrowseHover("show");
                        setBrowseMoreMediumDevice(true);
                        setTimeout(() => {
                          if (browseMoreContainerRef.current) {
                            const first = browseMoreContainerRef.current.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
                            if (first) first.focus();
                          }
                        }, 0);
                      }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                          e.preventDefault();
                          setBrowseHover("show");
                          setBrowseMoreMediumDevice(true);
                          setTimeout(() => {
                            if (browseMoreContainerRef.current) {
                              const first = browseMoreContainerRef.current.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
                              if (first) first.focus();
                            }
                          }, 0);
                        }
                      }}
                    >
                      <span><Translate textKey={'browse'} /></span>
                    </li>
                    {/* {
                projectInfo?.projectConfig?.config?.LIVE_REQUIRED ==="true"&&
              <li className={location?.pathname==="/player"?"active":""} onClick={()=>navigate("/player")}>
                <span>Live</span>
              </li>
              } */}
                    {projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" ? (
                      <li
                        className={location?.pathname === "/live-channels" ? "active" : ""}
                        onClick={() => navigate("/live-channels")}
                        role="menuitem"
                        tabIndex={0}
                        aria-label="Go to live channels"
                        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && navigate("/live-channels")}
                      >
                        <span>
                          {projectInfo?.projectConfig?.pubid === 50095
                            ? <Translate textKey={'free_tv'} />
                            : <Translate textKey={'live'} />}
                        </span>
                      </li>
                    ) : (
                      projectInfo?.projectConfig?.config?.LIVE_REQUIRED === "true" && (
                        <li
                          className={location?.pathname === "/player" || location?.pathname === "/live" ? "active" : ""}
                          onClick={() => navigate("/player")}
                          role="menuitem"
                          tabIndex={0}
                          aria-label="Go to live player"
                          onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && navigate("/player")}
                        >
                          <span>
                            {projectInfo?.projectConfig?.pubid === 50095
                              ? <Translate textKey={'free_tv'} />
                              : <Translate textKey={'live'} />}
                          </span>
                        </li>
                      )
                    )}
                    {projectInfo?.projectConfig?.config?.SHORTS_REQUIRED === "true" && user &&
                      <li
                        className={"shorts"}
                        onClick={() => navigate("/shorts")}
                        role="menuitem"
                        tabIndex={0}
                        aria-label="Go to shorts"
                        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && navigate("/shorts")}
                      >
                        <span>
                          <Translate textKey={'shorts'} />
                        </span>
                      </li>
                    }
                  </>
                )}


              {/* {template === 'TEMPLATE_9' && mainMenuItems?.map((item, index) => {

                return (
                  <li
                    key={index}
                    className={location?.pathname === "/category/" + item?.key ? "active mainMenu" : "mainMenu"}
                    onClick={() => menuNavigateHandler(item, setBrowseHover, setBrowseMoreMediumDevice)}
                  // style={{ padding: location?.pathname !== "/category/" + item?.key && '0px' }}
                  >
                    <span>{item?.value}</span>
                  </li>
                );
              })
              } */}

              {/* <li
                onClick={() => menuNavigateHandler({ key: "movies", value: "Films & Documentaries" })}
              >
                <span>Movies</span>
              </li> */}

              {/* <li
                onClick={() => menuNavigateHandler({ key: "series", value: "Series" })}
              >
                <span>Series</span>
              </li> */}

            </ul>
          </div>
          <div
            className={
              searchActive ? "rightContainer increase" : "rightContainer"
            }
            role="region"
            aria-label="User actions and search"
          >
            <div
              className={
                searchActive ? "inputContainer showInput" : "inputContainer"
              }
              ref={searchRefContainer}
              onClick={() => {
                setSearchActive(true);
                searchRef?.current.focus();
              }}
            >
              {searchActive ? (
                <SearchIcon
                  onClick={
                    // () => searchSubmit(inputValue)
                    () => searchSubmit(inputValue, setInputValue, setSearchActive, previousLocation)
                    // setSearchActive(!searchActive)
                  }
                />
              ) : (
                <SearchIcon
                  onClick={() => {
                    searchRef?.current.focus();
                    setSearchActive(true);
                  }}
                />
              )}
              <input
                ref={searchRef}
                className={`${theme === "LIGHT" ? 'white-bg' : ''}`}
                onClick={() => setSearchActive(true)}
                type="text"
                value={inputValue}
                placeholder={
                  !searchActive
                    ? translateText("search_placeholder") || "Find Movies, TV shows and more"
                    : ""
                }
                onChange={(e) => {
                  setInputValue(e?.target?.value);
                }}
                onKeyDown={(e) =>
                  e.key === "Enter" ?
                    searchSubmit(inputValue, setInputValue, setSearchActive, previousLocation)
                    : ""
                }
                style={{
                  fontFamily: projectInfo?.projectConfig?.pubid === 50147 ? 'Proxima-Nova' : template === 'TEMPLATE_9' ? 'Gilroy-Medium' : ''
                }}
              />
              {
                filterRequired === "true" && (
                  <FilterIcon
                    className="filterIcon"
                    onClick={() => {
                      setBrowseMoreMediumDevice(false);
                      if (inputValue) {
                        navigate(`/search?query=${encodeURIComponent(inputValue)}`);
                      } else {
                        navigate('/search');
                      }
                    }}
                    title="Filter"
                  />
                )
              }
            </div>
            {/* <i class="fa-regular fa-globe"></i> */}
            {/* <div className="language" onClick={()=>languageHandler()}>
              <i class="fa-solid fa-globe"></i>
              <span>{selectedLanguage!==null?selectedLanguage:"Language"}</span>

            </div> */}
            {projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true" && (
              <div
                className={`languageDropdown ${isLanguageOpen ? "active" : ""}`}
                onMouseOver={() => setIsLanguageOpen(true)}
                onMouseLeave={() => setIsLanguageOpen(false)}
                tabIndex={0}
                role="button"
                aria-haspopup="listbox"
                aria-expanded={isLanguageOpen}
                aria-label="Change language"
                onFocus={() => setIsLanguageOpen(true)}
                onBlur={e => {
                  if (!e.currentTarget.contains(e.relatedTarget)) setIsLanguageOpen(false);
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setIsLanguageOpen(v => !v);
                  } else if (e.key === 'Escape') {
                    setIsLanguageOpen(false);
                  } else if ((e.key === 'ArrowDown' || e.key === 'Down') && isLanguageOpen) {
                    e.preventDefault();
                    const first = e.currentTarget.querySelector('.languageOption');
                    if (first) first.focus();
                  }
                }}
              >
                <div className="language">
                  <Translate textKey={'change_language'} /> ({selectedLanguageCode})
                </div>

                {isLanguageOpen && (
                  <div className="languageOptions" role="listbox" aria-label="Language options">
                    <div className="optionsList">
                      {languageOptions?.map((language, idx) => (
                        <div
                          key={language.language_id}
                          data-selected={language.short_code === selectedLanguage.short_code}
                          className="languageOption"
                          role="option"
                          aria-selected={language.short_code === selectedLanguage.short_code}
                          tabIndex={0}
                          onClick={() => handleLanguageChange(language, setSelectedLanguage, setIsLanguageOpen, appInfo, projectInfo, getLanguageModal, getUserDetails, userDetails, languageOptions)}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleLanguageChange(language, setSelectedLanguage, setIsLanguageOpen, appInfo, projectInfo, getLanguageModal, getUserDetails, userDetails, languageOptions);
                            } else if (e.key === 'ArrowDown' || e.key === 'Down') {
                              e.preventDefault();
                              const next = e.currentTarget.nextSibling;
                              if (next) next.focus();
                            } else if (e.key === 'ArrowUp' || e.key === 'Up') {
                              e.preventDefault();
                              const prev = e.currentTarget.previousSibling;
                              if (prev) prev.focus();
                            } else if (e.key === 'Escape') {
                              setIsLanguageOpen(false);
                            }
                          }}
                        >
                          ({language.short_code}) {language.language_name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
            {user ? (
              <div
                className={userInfo ? "userInfo active" : "userInfo"}
                onMouseEnter={() => setUserInfo(true)}
                onMouseLeave={() => setUserInfo(false)}
                onFocus={() => {
                  if (justClosedUserInfo.current) {
                    justClosedUserInfo.current = false;
                    return;
                  }
                  setUserInfo(true);
                }}
                role="button"
                tabIndex={0}
                aria-haspopup="menu"
                aria-expanded={userInfo}
                aria-label="Open user menu"
                onBlur={e => {
                  setTimeout(() => {
                    const container = userInfoContainerRef.current;
                    const active = document.activeElement;
                    if (
                      e.currentTarget &&
                      active &&
                      !e.currentTarget.contains(active) &&
                      !(container && container.contains(active))
                    ) {
                      setUserInfo(false);
                    }
                  }, 0);
                }}
                onKeyDown={e => {
                  // setUserInfo(true);
                  if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
                    e.preventDefault();
                    lastInputWasKeyboard.current = true;
                    setUserInfo(true);
                    setTimeout(() => {
                      if (lastInputWasKeyboard.current) {
                        const menu = document.querySelector('.userInfoContainer.active ul');
                        if (menu) {
                          const first = menu.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
                          if (first) first.focus();
                        }
                      }
                    }, 0);
                  } else if (e.key === 'Tab' && userInfo) {
                    const menu = document.querySelector('.userInfoContainer.active ul');
                    if (menu) {
                      const first = menu.querySelector('a,button,[tabindex]:not([tabindex="-1"])');
                      if (first) {
                        e.preventDefault();
                        first.focus();
                      }
                    }
                  } else if (e.key === 'Escape') {
                    setUserInfo(false);
                  }
                }}
              >
                <h4 className={userInfo ? "active" : ""}><Translate textKey={'hi_message'} />, {userDetails?.first_name ? userDetails?.first_name : userDetails?.user_email?.split('@')[0]}</h4>
                <CircleArrow />
              </div>
            ) : (
              <div className="buttonContainer">
                {!isCheckoutPath && <button
                  className="register"
                  style={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? {
                    width: '100%',
                    padding: '10px 15px',
                    borderRadius: '4px'
                  } : {}}
                  onClick={() => {
                    localStorage.setItem("vanityUrl", '')
                    navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? "/checkout" : "/register")
                  }}
                  tabIndex={0}
                  aria-label="Register"
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      localStorage.setItem("vanityUrl", '')
                      navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' ? "/checkout" : "/register")
                    }
                  }}
                >
                  {(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT) ? <Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT} /> : <Translate textKey={'register'} />}
                </button>}
                {!isCheckoutPath && <button className={`signIn ${theme === 'LIGHT' ? 'black-text' : ''}`} onClick={() => {
                  localStorage.setItem("vanityUrl", '')
                  navigate(
                    "/login",
                    { state: { activeLogin: true } }
                  );
                }}
                  tabIndex={0}
                  aria-label="Sign in"
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      localStorage.setItem("vanityUrl", '')
                      navigate(
                        "/login",
                        { state: { activeLogin: true } }
                      );
                    }
                  }}
                >
                  {
                    projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === 'true'
                      ? <Translate textKey={'sign_in'} />
                      : <>
                        Sign&nbsp;In
                      </>
                  }
                  {/* Sign&nbsp;In */}
                </button>}
              </div>
            )}
          </div>
        </div>
      </div>
      <div ref={userInfoContainerRef} className={`userInfoContainer ${userInfo && headerVisible ? "active" : ""} ${theme === "LIGHT" ? "whiteBg" : ""}`}
        onMouseOver={() => setUserInfo(true)}
        onMouseLeave={() => setUserInfo(false)}
        onClick={() => setUserInfo(!userInfo)}
        aria-label="User info menu"
        role="menu"
        // tabIndex={userInfo ? 0 : -1}
        tabIndex={0}
        onKeyDown={handleUserInfoMenuKeyDown}
        onBlur={e => {
          setTimeout(() => {
            if (
              e.currentTarget &&
              document.activeElement &&
              !e.currentTarget.contains(document.activeElement)
            ) {
              setUserInfo(false);
            }
          }, 0);
        }}
      >
        <div className="top">
          <ul>
            <Link to="/account" tabIndex={0} role="menuitem" aria-label="Account settings">
              <li role="none">
                <span><Translate textKey={'account_settings'} /></span>
              </li>
            </Link>
            <Link to="/my-list" tabIndex={0} role="menuitem" aria-label="My list">
              <li role="none">
                <span><Translate textKey={'my_list'} /></span>
              </li>
            </Link>
            {/* Video Quality Dropdown */}

            {showVideoQualityDropdown && (
              <div style={{ marginBottom: '15px', width: '122px' }}>
                <label htmlFor="video-quality-select" style={{ fontWeight: 500, marginBottom: '10px' }}>Stream Quality:</label>
                <select
                  id="video-quality-select"
                  style={{
                    padding: '5px 0px',
                    borderRadius: '4px',
                    border: 'transparent',
                    width: '100%',
                    margin: '0',
                    cursor: 'pointer',
                  }}
                  defaultValue={typeof window !== 'undefined' && localStorage.getItem('videoSelectedResolution') || 'Auto'}
                  onClick={e => e.stopPropagation()}
                  onChange={e => {
                    e.stopPropagation();
                    if (typeof window !== 'undefined') {
                      if (e.target.value === 'Auto') {
                        localStorage.removeItem('videoSelectedResolution');
                      } else {
                        localStorage.setItem('videoSelectedResolution', e.target.value);
                      }
                      const pathSegments = window.location.pathname.split('/');
                      if (pathSegments.length > 2 && pathSegments[pathSegments.length - 2] === 'videos') {
                        window.location.reload();
                      }
                    }
                  }}
                >
                  <option value="Auto">Auto</option>
                  <option value="1080p">1080p (Full HD)</option>
                  <option value="720p">720p (HD)</option>
                  <option value="480p">480p (SD)</option>
                  <option value="360p">360p (Low)</option>
                </select>
              </div>
            )}

            {projectInfo?.projectConfig?.pubid === 50147 ?
              <Link to="/contact-support" tabIndex={0} role="menuitem" aria-label="Link TV app">
                <li role="none">
                  <span><Translate textKey={'contact_us'} /></span>
                </li>
              </Link> :
              <Link to="/tv" tabIndex={0} role="menuitem" aria-label="Link TV app">
                <li role="none">
                  <span><Translate textKey={'link_tv_app'} /></span>
                </li>
              </Link>
            }
            {projectInfo?.projectConfig?.config?.SUBSCRIPTION_REQUIRED === 'true' &&
              (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true' && !isSubscribedUser ? (<Link to="/checkout" tabIndex={0} role="menuitem" aria-label="Subscribe">
                <li role="none">
                  {user ? (
                    <span><Translate textKey="subscribe" /></span>
                  ) : (
                    <span>
                      <Translate textKey={projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_BUTTON_TEXT} />
                    </span>
                  )}
                </li>
              </Link>
              ) : !isSubscribedUser && (<Link to="/subscription" tabIndex={0} role="menuitem" aria-label="Subscription plans">
                <li role="none">
                  <span> <Translate textKey={'subscription_plans'} /> </span>
                </li>
              </Link>))
            }
            {/* {projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true" && (
                  <Link to="/language-selection" onClick={languageHandler}>
                    <li>
                      <span className="language">
                        <Translate textKey={'change_language'} />
                      </span>
                    </li>
                  </Link>
                ) } */}
          </ul>
        </div>
        <div className={`bottom ${theme === "LIGHT" ? "whiteGrad" : ""}`}>
          <div className="signOutContainer" onClick={() => logoutHandler(appInfo)}
            aria-label="Sign out"
            role="menuitem"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') logoutHandler(appInfo);
            }}
            type="button"
          >
            <SignOutIcon />
            <span><Translate textKey={'sign_out'} /></span>
          </div>
        </div>
      </div>
      <div
        className={browseHover === "show" ? "browseMore active" : "browseMore"}
        role="dialog"
        aria-modal="true"
        aria-label="Browse more menu"
        tabIndex={browseHover === "show" ? 0 : -1}
        aria-hidden={browseHover !== "show"}
        ref={browseMoreContainerRef}
        aria-expanded={browseHover === "show"}
        onKeyDown={handleBrowseMoreKeyDown}
      >
        <div className="overlay"></div>

        {
          template === 'TEMPLATE_9' ?
            (
              <div
                className="browseMoreContainerNew"
                onMouseOver={() => setBrowseHover("show")}
                onMouseLeave={() => setBrowseHover(null)}
                role="menu"
                tabIndex={0}
                aria-label="Browse more categories"
                ref={browseMoreContainerRef}
                onBlur={e => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setBrowseHover(null);
                    setBrowseMoreMediumDevice(false);
                  }
                }}
              >
                {projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" && (

                  <div className="categoryContainer" style={{ '--buttonColorRgb': buttonColorRgb, '--buttonSelection': buttonSelection }}>
                    <h1 className="categoryName"><Translate textKey={'links'} /></h1>
                    <li>
                      <li onClick={() => navigate("/live-channels")}>
                        <div className="shadeGradient"
                          style={{
                            background: `linear-gradient(270deg, rgba(${buttonColorRgb}, 0) 0%, rgb(${buttonColorRgb}) 100%)`,
                          }}
                        ></div>
                        <span><Translate textKey={'live_channels'} /></span>
                      </li>
                    </li>
                  </div>
                )}
                {menuItems?.map((item, index) => (
                  <div className="categoryContainer" style={{ '--buttonColorRgb': buttonColorRgb, '--buttonSelection': buttonSelection }} key={index}>
                    <h1 className="categoryName">{item?.key}</h1>
                    <li cl>
                      {item?.items?.map((itemShow, keyIndex) => (
                        <li key={keyIndex}

                          onClick={() => {
                            setBrowseHover(null);
                            setBrowseMoreMediumDevice(false);
                            menuNavigateHandler(itemShow, setBrowseHover, setBrowseMoreMediumDevice);
                            requestAnimationFrame(() => {
                              if (document.activeElement) document.activeElement.blur();
                            });
                          }}
                          role="menuitem"
                          tabIndex={0}
                          aria-label={itemShow?.value}
                          onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') {


                              // setBrowseHover(null);
                              // setBrowseMoreMediumDevice(false);
                              // // menuNavigateHandler(itemShow, setBrowseHover, setBrowseMoreMediumDevice);
                              // setTimeout(() => {
                              //   menuNavigateHandler(itemShow, setBrowseHover, setBrowseMoreMediumDevice);
                              //   if (document.activeElement) document.activeElement.blur();
                              // }, 100);

                            }
                          }}
                        >
                          <div
                            className="shadeGradient"
                            style={{
                              background: `linear-gradient(270deg, rgba(${buttonColorRgb}, 0) 0%, rgb(${buttonColorRgb}) 100%)`,
                            }}
                          ></div>
                          <span>{itemShow?.value}</span>
                        </li>
                      ))}
                    </li>
                  </div>
                ))}
              </div>
            ) :
            (
              <div
                className="browseMoreContainer"
                onMouseOver={() => setBrowseHover("show")}
                onMouseLeave={() => setBrowseHover(null)}
                ref={browseMoreContainerRef}
                tabIndex={-1}
                onFocus={() => setBrowseHover("show")}
                onBlur={(e) => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setBrowseHover(null);
                    setBrowseMoreMediumDevice(false);
                  }
                }}
              >
                {mainMenuItems?.length === 0 && (
                  <>
                    {
                      projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" && (
                        <div className="left">
                          <h1 className="categoryName"><Translate textKey={'links'} /></h1>
                          <ul>
                            <li onClick={() => {
                              // setBrowseHover(null);
                              // setBrowseMoreMediumDevice(false);
                              navigate("/live-channels");

                              document.activeElement.blur();
                            }}
                              role="menuitem"
                              tabIndex={0}
                              aria-label="Go to live channels"
                              onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  navigate("/live-channels");
                                  // setBrowseHover(null);
                                  // setBrowseMoreMediumDevice(false);
                                  document.activeElement.blur();
                                }
                              }}
                            >
                              <span><Translate textKey={'live_channels'} /></span>
                            </li>
                          </ul>
                        </div>
                      )}
                    {menuItems?.map((item, index) => (
                      <div className="left" key={index}>
                        <h1 className="categoryName">{item?.key}</h1>
                        <ul>
                          {item?.items?.map((itemShow, keyIndex) => (
                            <li key={keyIndex}
                              onClick={() => {
                                setBrowseHover(null);
                                setBrowseMoreMediumDevice(false);
                                menuNavigateHandler(itemShow, setBrowseHover, setBrowseMoreMediumDevice);
                                requestAnimationFrame(() => {
                                  if (document.activeElement) document.activeElement.blur();
                                });
                              }}
                              role="menuitem"
                              tabIndex={0}
                              aria-label={itemShow?.value}
                              onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  setBrowseHover(null);
                                  setBrowseMoreMediumDevice(false);
                                  menuNavigateHandler(itemShow, setBrowseHover, setBrowseMoreMediumDevice);
                                  requestAnimationFrame(() => {
                                    if (document.activeElement) document.activeElement.blur();
                                  });
                                }
                              }}
                            >
                              <span>{itemShow?.value}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )
        }
      </div>

      <div className="browseMoreResponsive"
        aria-label="Browse more responsive menu"
        role="dialog"
        aria-modal="true"
      >
        <div
          className={browseMoreMediumDevice ? "container active" : "container"}
          ref={browseMoreContainerRef}
          tabIndex={browseMoreMediumDevice ? 0 : -1}
          aria-hidden={!browseMoreMediumDevice}
          role="menu"
          onKeyDown={e => {
            const focusable = Array.from(e.currentTarget.querySelectorAll('button,a,[tabindex]:not([tabindex="-1"])'));
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (e.key === 'Tab') {
              if (focusable.length === 0) return;
              if (e.shiftKey) {
                if (document.activeElement === first) {
                  e.preventDefault();
                  last.focus();
                }
              } else {
                if (document.activeElement === last) {
                  e.preventDefault();
                  first.focus();
                }
              }
            } else if (e.key === 'Escape') {
              setBrowseMoreMediumDevice(false);
            } else if (e.key === 'ArrowDown') {
              e.preventDefault();
              const idx = focusable.indexOf(document.activeElement);
              if (idx > -1 && idx < focusable.length - 1) {
                focusable[idx + 1].focus();
              } else if (idx === focusable.length - 1) {
                first.focus();
              }
            } else if (e.key === 'ArrowUp') {
              e.preventDefault();
              const idx = focusable.indexOf(document.activeElement);
              if (idx > 0) {
                focusable[idx - 1].focus();
              } else if (idx === 0) {
                last.focus();
              }
            }
          }}
        >
          <div className="head large">
            <div className="left">
              <h1><Translate textKey={'browse'} /></h1>
            </div>
            <div className="right">
              <CloseIcon onClick={() => setBrowseMoreMediumDevice(false)} />
            </div>
          </div>
          <div className="head small">
            <div className="left">
              <CloseIcon onClick={() => setBrowseMoreMediumDevice(false)} />
              <span><Translate textKey={'close'} /></span>
            </div>
            <div className={searchActive ? "right increase" : "right"}>
              <div
                className={
                  searchActive ? "inputContainer showInput" : "inputContainer"
                }
                ref={searchRefSmallContainer}
              >
                <SearchIcon
                  onClick={() => {
                    // searchResultsShow();
                    // searchSubmitBrowseMore(inputValue);
                    searchSubmitBrowseMore(inputValue, setInputValue, setSearchActive, setBrowseMoreMediumDevice, previousLocation)
                  }}
                />

                <input
                  ref={searchRefSmall}
                  className={`${theme === "LIGHT" ? 'white-bg' : ''}`}
                  onClick={() => {
                    setSearchActive(true);
                  }}
                  type="text"
                  value={inputValue}
                  placeholder={
                    !searchActive
                      ? translateText("search_placeholder") || "Find Movies, TV shows and more"
                      : ""
                  }
                  onChange={(e) => {
                    // searchHandleChange(e?.target?.value);
                    setInputValue(e?.target?.value);
                  }}
                  onKeyDown={(e) =>
                    e.key === "Enter" ?
                      // searchSubmitBrowseMore(inputValue) 
                      searchSubmitBrowseMore(inputValue, setInputValue, setSearchActive, setBrowseMoreMediumDevice, previousLocation)
                      : ""
                  }
                />

                {
                  filterRequired === "true" && (
                    <FilterIcon
                      className="filterIcon"
                      onClick={() => {
                        setBrowseMoreMediumDevice(false);
                        if (inputValue) {
                          navigate(`/search?query=${encodeURIComponent(inputValue)}`);
                        } else {
                          navigate('/search');
                        }
                      }}
                      title="Filter"
                    />
                  )
                }

              </div>
            </div>
          </div>

          {/* <div className="language" onClick={()=>languageHandler()}>
              <i class="fa-solid fa-globe"></i>
              <span>{selectedLanguage!==null?selectedLanguage:"Language"}</span>
            </div> */}

          {mainMenuItems?.length !== 0 ? (
            mainMenuItems?.map((menu, index) => (
              <div className="top" key={index}>
                {menu?.type === "MENU" && (
                  <>
                    <h1 className="categoryName">{menu?.value}</h1>
                    <ul className="nestedMenu">
                      {menu?.items?.map((subItem, subIndex) => {
                        if (subItem?.type === "MENU") {
                          return (
                            <li key={subIndex}>
                              <h1 className="categoryName">{subItem?.value}</h1>
                              <ul onClick={() => setBrowseMoreMediumDevice(false)}>{renderMenuItems(subItem?.items, location.pathname, activeMenuTracker, setActiveMenuTracker, undefined, setBrowseHover, setBrowseMoreMediumDevice)}</ul>
                            </li>
                          );
                        } else if (subItem?.type === "LINK") {
                          return (
                            <li
                              key={subIndex}
                              className="link"
                              tabIndex={0}
                              role="menuitem"
                              aria-label={subItem?.value}
                              onClick={() => {
                                if (subItem?.seo_url) {
                                  setBrowseHover(null);
                                  setBrowseMoreMediumDevice(false);
                                  navigate(`/${subItem?.seo_url}`);
                                  setBrowseMoreMediumDevice(false);
                                } else if (subItem?.link) {
                                  setBrowseHover(null);
                                  setBrowseMoreMediumDevice(false);
                                  window.open(subItem?.link, "_blank");
                                  setBrowseMoreMediumDevice(false);
                                }
                              }}
                              onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                  if (subItem?.seo_url) {
                                    setBrowseHover(null);
                                    setBrowseMoreMediumDevice(false);
                                    navigate(`/${subItem?.seo_url}`);
                                    setBrowseMoreMediumDevice(false);
                                  } else if (subItem?.link) {
                                    setBrowseHover(null);
                                    setBrowseMoreMediumDevice(false);
                                    window.open(subItem?.link, "_blank");
                                    setBrowseMoreMediumDevice(false);
                                  }
                                }
                              }}
                            >
                              <span>{subItem?.value}</span>
                            </li>
                          );
                        }
                        return null;
                      })}
                    </ul>
                  </>
                )}
                {menu?.type === "LINK" && (
                  <li
                    className="straightLink"
                    tabIndex={0}
                    role="menuitem"
                    aria-label={menu?.value}
                    onClick={() => {
                      if (menu?.seo_url) {
                        setBrowseHover(null);
                        setBrowseMoreMediumDevice(false);
                        navigate(`/${menu?.seo_url}`);
                        setBrowseMoreMediumDevice(false);
                      } else if (menu?.link) {
                        setBrowseHover(null);
                        setBrowseMoreMediumDevice(false);
                        window.open(menu?.link, "_blank");
                        setBrowseMoreMediumDevice(false);
                      }
                    }}
                    onKeyDown={e => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        if (menu?.seo_url) {
                          setBrowseHover(null);
                          setBrowseMoreMediumDevice(false);
                          navigate(`/${menu?.seo_url}`);
                          setBrowseMoreMediumDevice(false);
                        } else if (menu?.link) {
                          setBrowseHover(null);
                          setBrowseMoreMediumDevice(false);
                          window.open(menu?.link, "_blank");
                          setBrowseMoreMediumDevice(false);
                        }
                      }
                    }}
                  >
                    <span>{menu?.value}</span>
                  </li>
                )}
              </div>
            ))
          ) : (
            <>
              {
                projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" ||
                  projectInfo?.projectConfig?.config?.LIVE_REQUIRED === "true" ? (

                  <div className="top">
                    <h1 className="categoryName"><Translate textKey={'links'} /></h1>
                    <ul>
                      {
                        projectInfo?.projectConfig?.config?.LIVE_REQUIRED === "true" &&
                        <li onClick={() => { navigate("/player"); setBrowseMoreMediumDevice(false) }}><span><Translate textKey={'live'} /></span></li>
                      }
                      {
                        projectInfo?.projectConfig?.config?.MULTI_CHANNELS_REQUIRED === "true" &&
                        <li onClick={() => { navigate("/live-channels"); setBrowseMoreMediumDevice(false) }}><span><Translate textKey={'live_channels'} /></span></li>
                      }
                    </ul>
                  </div>
                ) : null
              }
              {projectInfo?.projectConfig?.config?.SHORTS_REQUIRED === "true" && user &&
                <div className="top">
                  <h1 className="categoryName"><Translate textKey={'shorts'} /></h1>
                  <ul>
                    <li
                      tabIndex={0}
                      role="menuitem"
                      aria-label="Shorts"
                      onClick={() => { navigate("/shorts"); setBrowseMoreMediumDevice(false); setActiveMenuTracker({ path: "/shorts/", menuPath: `shorts` }); }}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          navigate("/shorts");
                          setBrowseMoreMediumDevice(false);
                          setActiveMenuTracker({ path: "/shorts/", menuPath: `shorts` });
                        }
                      }}
                    >
                      <span><Translate textKey={'shorts'} /></span>
                    </li>


                  </ul>
                </div>
              }
              {menuItems?.map((item, index) => (
                <div className="top" key={index}>
                  <h1 className="categoryName">{item?.key}</h1>
                  <ul>
                    {item?.items?.map((items, i) => (
                      <li key={i}
                        tabIndex={0}
                        role="menuitem"
                        aria-label={items?.value}
                        onClick={() => {
                          setBrowseHover(null);
                          setBrowseMoreMediumDevice(false);
                          menuNavigateHandler(items, setBrowseHover, setBrowseMoreMediumDevice);
                          requestAnimationFrame(() => {
                            if (document.activeElement) document.activeElement.blur();
                          });
                        }}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            setBrowseHover(null);
                            setBrowseMoreMediumDevice(false);
                            menuNavigateHandler(items, setBrowseHover, setBrowseMoreMediumDevice);
                            requestAnimationFrame(() => {
                              if (document.activeElement) document.activeElement.blur();
                            });
                          }
                        }}
                      >
                        <span> {items?.value}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </>
          )}
          {projectInfo?.projectConfig?.config?.MULTI_LANGUAGE_REQUIRED === "true" && (
            <div
              className={`languageDropdown ${isLanguageOpen ? "active" : ""}`}
              onClick={(e) => handleLanguageClick(e, setIsLanguageOpen, browseMoreContainerRef)}
            >
              <h1 className="language">
                <Translate textKey={'change_language'} /> ({selectedLanguageCode})
              </h1>

              {isLanguageOpen && (
                <div className="languageOptions">
                  <div className="optionsList">
                    {languageOptions?.map((language) => (
                      <div
                        key={language.language_id}
                        data-selected={language.short_code === selectedLanguage.short_code}
                        className="languageOption"
                        onClick={() => handleLanguageChange(language, setSelectedLanguage, setIsLanguageOpen, appInfo, projectInfo, getLanguageModal, getUserDetails, userDetails, languageOptions)}
                      >
                        ({language.short_code}) {language.language_name}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
